var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setTitle(),
            visible: _vm.show,
            width: "600px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "user",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.formValidate,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("yhzh"), prop: "account" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.formType == "examine" || _vm.formType == "detail",
                      placeholder: _vm.$t("qsryhzh"),
                    },
                    model: {
                      value: _vm.formValidate.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "account", $$v)
                      },
                      expression: "formValidate.account",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("sfzh"), prop: "idcard" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      disabled:
                        _vm.formType == "examine" || _vm.formType == "detail",
                      placeholder: _vm.$t("qsrsfzh"),
                    },
                    model: {
                      value: _vm.formValidate.idcard,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "idcard", _vm._n($$v))
                      },
                      expression: "formValidate.idcard",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("sfzzm"), prop: "idcard_front_image" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row upLoadPicBox row-middle" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "",
                            disabled: "",
                            "http-request": _vm.handleUploadForm1,
                            headers: _vm.myHeaders,
                            "show-file-list": false,
                          },
                        },
                        [
                          _vm.formValidate.idcard_front_image
                            ? _c(
                                "div",
                                {
                                  staticClass: "pictrue",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showbigImg(
                                        _vm.formValidate.idcard_front_image
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.setUrl(
                                        _vm.formValidate.idcard_front_image
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("sfzfm"), prop: "idcard_side_image" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row upLoadPicBox row-middle" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "",
                            disabled: "",
                            "http-request": _vm.handleUploadForm2,
                            headers: _vm.myHeaders,
                            "show-file-list": false,
                          },
                        },
                        [
                          _vm.formValidate.idcard_side_image
                            ? _c(
                                "div",
                                {
                                  staticClass: "pictrue",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showbigImg(
                                        _vm.formValidate.idcard_side_image
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.setUrl(
                                        _vm.formValidate.idcard_side_image
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.formType == "examine" || _vm.formType == "detail"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("shzt"), prop: "review_status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.formType == "detail" },
                          on: { change: _vm.changeStatus },
                          model: {
                            value: _vm.review_status,
                            callback: function ($$v) {
                              _vm.review_status = $$v
                            },
                            expression: "review_status",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { disabled: "", label: 0 } },
                            [_vm._v(_vm._s(_vm.$t("wsh")))]
                          ),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("shtg"))),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("shwtg"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.review_status == 2,
                      expression: "review_status == 2",
                    },
                  ],
                  attrs: { label: _vm.$t("ly") },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.formType == "detail",
                      placeholder:
                        _vm.review_status == 1
                          ? _vm.$t("qsrtgly")
                          : _vm.$t("qsrjjly"),
                    },
                    model: {
                      value: _vm.formValidate.explain,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "explain", $$v)
                      },
                      expression: "formValidate.explain",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("formValidate")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("calcelText")))]
              ),
              _vm._v(" "),
              _vm.formType != "detail"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("formValidate")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("trueText")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("tupianyulan"),
            visible: _vm.imgShow,
            width: "700px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "show-cr-img" }, [
            _c("img", { attrs: { src: _vm.setUrl(_vm.currImg), alt: "" } }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("formValidate")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("guanbi")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }